import React from 'react'
import './Services.css'
import HeartEmoji from "../../img/heartemoji.png";
import Glasses from "../../img/glasses.png";
import Humble from "../../img/humble.png";
import Card from '../Card/Card';
import Resume from './RAVI TANDAN.pdf' 
import { themeContext } from '../../Context';
import { useContext } from 'react';
const Services=()=> {
    const theme = useContext(themeContext)
    const darkMode = theme.state.darkMode
    return (
        <div className="services" id='Services'>
            <div className="awesome">
                <span style={{color: darkMode? 'white' : ''}}>My Awesome</span>
                <span>Services</span>
                <span>
                     I work on E-commerce website and student protfolio.
                    <br/>
                    Also work on real life project.
                    <br/>
                    I am Full Stack Developer.
                </span>
                <a href={Resume} download>
                    <button className="button s-button">Download CV</button>
                </a>
                <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
            </div>
            {/* Right Side */}
            <div className="cards">
                <div style={{ left: '14rem' }}>
                    <Card
                        emoji={HeartEmoji}
                        heading={'Design'}
                        detail={"Figma, Photoshop, Adob xd, Canva ,Animated logo"}
                    />
                </div>
                {/* Second Card */}
                <div style={{ top: "12rem", left: "-4rem" }}>
                    <Card
                        emoji={Glasses}
                        heading={'Developer'}
                        detail={"HTML, CSS(Animation pro), JavaScript, React"}
                    />
                </div>
                {/* Third Card */}
                <div style={{ top: "17rem", left: "12rem" }}>
                    <Card
                        emoji={Humble}
                        heading={'UI/UX '}
                        detail={"Creating user Experience and Interface design"}
                    />
                </div>
                <div className="blur s-blur2" style={{background: "var(--purple)"}}></div>
            </div>
        </div>
    )
}

export default Services
